<template>
  <v-card class="mb-3" style="border-color: #ddd" variant="outlined">
    <v-card-text>
      <div class="d-flex align-start justify-space-between ga-4">
        <div class="min-w-0">
          <div class="text-disabled font-size-12">
            {{ plan.year }}
            <span> · Створено {{ new CustomDate(plan.created_at) }}</span>
          </div>
          <div class="font-size-18 font-weight-bold">
            {{ plan.name }}
          </div>
        </div>

        <v-btn
          class="text-none me-2"
          style="border-color: #ddd"
          variant="outlined"
          @click.stop="planUpdate">
          <span class="font-weight-medium">Редагувати</span>
        </v-btn>
      </div>

      <v-divider class="my-3" />

      <v-row align="start" class="ma-0">
        <v-col class="pa-0 pe-md-8" cols="12" md="4">
          <b-label class="font-weight-bold text-disabled font-size-12"
            >АУДИТОР
          </b-label>
          <button
            class="link text-decoration-none"
            type="button"
            @click.stop="openAuthorCard">
            {{ getPersonName(plan.author) }}
          </button>
        </v-col>

        <v-col class="pa-0 pe-md-8" cols="12" md="4">
          <b-label class="font-weight-bold text-disabled font-size-12">
            АУДИТІВ У ПЛАНІ
          </b-label>
          <div class="metric-value">
            {{ plan.progress?.total }}
          </div>
        </v-col>

        <v-col class="pa-0" cols="12" md="4">
          <b-label class="font-weight-bold text-disabled font-size-12">
            ПРОГРЕС ВИКОНАННЯ
          </b-label>
          <div class="d-flex align-center ga-4">
            <v-progress-linear
              :model-value="
                100 / ((plan.progress?.total || 1) / plan.progress?.completed)
              "
              bg-color="grey"
              class="flex-grow-1"
              color="primary"
              height="7"
              rounded />
            <div class="text-disabled text-no-wrap">
              {{ plan.progress?.completed }} / {{ plan.progress?.total }}
            </div>
          </div>
        </v-col>
      </v-row>

      <div v-if="$slots.append">
        <v-divider class="my-3" />

        <slot name="append"></slot>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { BLabel } from 'best-modules/components'
import { CustomDate, getPersonName } from 'best-modules/utils'
import { openDialog } from '@/dialog'
import { openUserCardDialog } from '@/utils/userCardDialog'

export default {
  name: 'PlanItem',
  components: { BLabel },
  emits: ['update'],
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  methods: { getPersonName, CustomDate },
  setup(props, { emit }) {
    const planUpdate = () => {
      return openDialog({
        name: 'Plan',
        action: 'update',
        dialogData: {
          plan: props.plan,
        },
        params: {
          cb: updatedPlan => {
            emit('update', updatedPlan)
          },
        },
      })
    }

    const openAuthorCard = () => {
      openUserCardDialog({
        userId: props.plan.authorId,
        mode: 'employee',
        context: 'list',
        title: getPersonName(props.plan.author),
      })
    }

    return { openAuthorCard, planUpdate }
  },
}
</script>

<style lang="scss" scoped>
.link {
  background: transparent;
  border: 0;
  color: rgb(var(--v-theme-primary));
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}
</style>
